import React from "react";
import { useIntl } from "react-intl";
import styles from "./DownloadsPage.module.scss";
import i18n from "./DownloadsPage.i18n";
import entries from "../../../../data/downloads/all";
import DownloadEntryWindow from "./components/DownloadEntryWindow/DownloadEntryWindow";
import { DefaultPage } from "../../../common";
import defaultPageStyle from "../../../common/DefaultPage/DefaultPage.module.scss";

export default function DownloadsPage(): React.ReactElement {
  const { formatMessage } = useIntl();

  return (
    <DefaultPage header={formatMessage(i18n.downloads)} className={styles.page}>
      <div className={defaultPageStyle.row}>
        {entries.map((entry) => (
          <DownloadEntryWindow key={entry.id} entry={entry} className={styles.window} />
        ))}
      </div>
    </DefaultPage>
  );
}
